import { createDeleteButton } from "./../_shared/plugin-toolbar/create-delete-button.js";
import { createNodeAlignmentButton } from "./../_shared/plugin-toolbar/create-node-alignment-button.js";
import { createReplaceButton } from "./../_shared/plugin-toolbar/create-replace-button.js";
import { createNodeSizeButton } from "./../_shared/plugin-toolbar/node-size-button/create-node-size-button.js";
import { createSeparator } from "./../_shared/plugin-toolbar/separator/create-separator.js";
import { isVisibleOnlyOnDesktop } from "./../_shared/resolvers/is-visible-only-on-desktop.js";
import { handleFileUpload } from ".//handle-file-upload.js";
import { FILE_BUTTONS } from "./consts.js";
const getToolbarButtons = (config, services) => {
  const {
    context: { isMobile }
  } = services;
  return [
    createNodeSizeButton({
      services,
      modalId: FILE_BUTTONS.size,
      options: ["SMALL", "CONTENT"]
    }),
    createSeparator({
      visible: isVisibleOnlyOnDesktop(isMobile)
    }),
    createNodeAlignmentButton({ services, modalId: FILE_BUTTONS.alignment }),
    createSeparator({
      visible: isVisibleOnlyOnDesktop(isMobile)
    }),
    createReplaceButton({
      tooltip: "FileUploadReplaceButton_tooltip",
      command: ({ attributes: { selectedNode }, publicCommands }) => {
        handleFileUpload({ config, services, publicCommands, nodeId: selectedNode.attrs.id });
      }
    }),
    createSeparator(),
    createDeleteButton()
  ];
};
export {
  getToolbarButtons
};
//# sourceMappingURL=getToolbarButtons.js.map
